import WebSocket from "ws";
function setServerWebSocket() {
  var _globalThis, _WebSocket;
  (_globalThis = globalThis)[_WebSocket = "WebSocket"] || (_globalThis[_WebSocket] = WebSocket);
}
export {
  setServerWebSocket
};
//# sourceMappingURL=setServerWebSocket.js.map
